var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 7.5H29.645C28.5275 3.2 24.6475 0 20 0C14.8475 0 5 3.895 5 10C5 16.105 14.8475 20 20 20C24.6475 20 28.5275 16.8 29.645 12.5H52.5C53.8825 12.5 55 11.38 55 10C55 8.62 53.8825 7.5 52.5 7.5ZM0 40C0 38.62 1.1175 37.5 2.5 37.5H3.66L3.8325 36.04C4.575 29.745 9.9125 25 16.2475 25H43.7575C50.0925 25 55.43 29.745 56.1725 36.04L56.345 37.5H57.505C58.8875 37.5 60.005 38.62 60.005 40C60.005 41.38 58.8875 42.5 57.505 42.5H2.5C1.1175 42.5 0 41.38 0 40ZM56.34 47.5L56.1675 48.96C55.425 55.255 50.0875 60 43.7525 60H16.245C9.91 60 4.5725 55.255 3.83 48.96L3.6575 47.5H23.0475L23.35 48.7125C23.9075 50.9425 25.9025 52.5 28.2 52.5H31.795C34.095 52.5 36.09 50.9425 36.645 48.7125L36.9475 47.5H56.34Z",
    fill: "#548054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeals);
export default __webpack_public_path__ + "static/media/meals.3d3b650aaa1b7f94e11841e981931e90.svg";
export { ForwardRef as ReactComponent };